import React from "react"

import Divider from "./Divider";
import EditCoachingPlanHead, { ViewState } from "./EditCoachingPlanHead";
import WeeklyPlanEditor from "./WeeklyPlanEditor";
import PersonalRoutineEditor from "./PersonalRoutineEditor";

const CompletedFutureWeekView = ({
    activityStats=null,
    coachingPlan,
    constPlan=null,
    constRoutine=null,
    name,
    selectedWeek,
    weekOptions,
    // Callbacks
    onChangeWeek,
    onStartNewPlan
}) => {
    return (
        <div className="w-[100%] p-10 flex-col justify-center items-center gap-y-6 inline-flex">
            <div id="head" className="w-full justify-center items-center gap-x-3 inline-flex">
                <EditCoachingPlanHead
                    coachingPlan={coachingPlan}
                    selectedWeek={selectedWeek}
                    state={ViewState.Cancelled}
                    weekOptions={weekOptions}
                    // Callbacks
                    onStartNewPlan={onStartNewPlan}
                    setSelectedWeekCallback={onChangeWeek}
                />
            </div>
            <div id="divider" className="w-full justify-center items-center gap-x-3 inline-flex bg-green-100">
                <Divider label={"Assignments"}/>
            </div>
            <div id="divider" className="w-full justify-center items-center gap-3 inline-flex rounded-[10px] shadow border border-gray-200">
                <PersonalRoutineEditor
                    activityStats={activityStats}
                    constRoutine={constRoutine}
                    firstName={name}
                    state={ViewState.Cancelled}
                />
            </div>
            <div id="divider" className="w-full justify-center items-center gap-3 inline-flex rounded-[10px] shadow border border-gray-200">
                <WeeklyPlanEditor
                    activityStats={activityStats}
                    coachingPlan={coachingPlan}
                    constPlan={constPlan}
                    selectedWeek={selectedWeek}
                    state={ViewState.Cancelled}
                />
            </div>
        </div>
    )
}

export default CompletedFutureWeekView